import { DecoratorNode } from "lexical";

// Chip node for contract variables. The `isSignature` flag drives both the
// visual variant (blue accent) and the Save-validation check that ensures every
// contract carries a place for the client to sign.
export class VariableNode extends DecoratorNode {
  __variableName;
  __displayName;
  __isSignature;

  static getType() {
    return "contract-variable";
  }

  static clone(node) {
    return new VariableNode(
      node.__variableName,
      node.__displayName,
      node.__isSignature,
      node.__key
    );
  }

  constructor(variableName, displayName, isSignature = false, key) {
    super(key);
    this.__variableName = variableName;
    this.__displayName = displayName;
    this.__isSignature = !!isSignature;
  }

  getVariableName() {
    return this.__variableName;
  }

  isSignature() {
    return this.__isSignature;
  }

  createDOM() {
    const span = document.createElement("span");
    span.className = this.__isSignature
      ? "contract-chip contract-chip-signature"
      : "contract-chip";
    span.setAttribute("contenteditable", "false");
    span.setAttribute("data-chip", this.__variableName);
    span.textContent = this.__displayName;
    return span;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return null;
  }

  // Serialize to `{Var_Name}` text — matches the backend's placeholder syntax
  // (see Docs/API/contract.md). ContentInitPlugin walks the imported tree and
  // converts these text patterns back into VariableNodes on load, so there is
  // no round-trip via `<span data-chip>`.
  exportDOM() {
    return { element: document.createTextNode(`{${this.__variableName}}`) };
  }

  static importDOM() {
    // Text-node conversion is done imperatively in ContentInitPlugin because
    // `$generateNodesFromDOM` does not surface text nodes to importDOM at
    // per-node granularity.
    return null;
  }

  getTextContent() {
    return this.__displayName;
  }

  isInline() {
    return true;
  }

  exportJSON() {
    return {
      type: "contract-variable",
      variableName: this.__variableName,
      displayName: this.__displayName,
      isSignature: this.__isSignature,
      version: 1,
    };
  }

  static importJSON(json) {
    return new VariableNode(
      json.variableName,
      json.displayName,
      json.isSignature
    );
  }
}

export const $createVariableNode = (variableName, displayName, isSignature) =>
  new VariableNode(variableName, displayName, isSignature);

export const $isVariableNode = (node) => node instanceof VariableNode;
